import React from 'react'

import clsx from 'clsx'

import Banner from 'components/Banner'
import Typography from 'components/Typography'

import CtaGetList from '../Top10/components/CtaGetList'

import classes from './GetListBanner.module.scss'

/** @type {import("./types").default} */
const GetListBanner = ({ className, ...props }) => (
  <Banner className={clsx('GetListBanner', classes.root, className)} {...props}>
    <Typography variant="title-8">Get a copy of this list</Typography>
    <div className={classes.content}>
      <Typography variant="body-xs" className={classes.description}>
        Get a copy of this list with pricing info sent to your inbox so you can pick up where you left off when
        convenient for you.
      </Typography>

      <CtaGetList />
    </div>
  </Banner>
)

export default GetListBanner
